/* Compact mobile launcher shared by every storefront page. */
(() => {
  let attempts = 0;
  const mount = () => {
    const root = document.querySelector('[data-permut-main]')?.shadowRoot;
    if (!root) return false;
    if (!root.querySelector('[data-ani-mobile-chat]')) {
      const style = document.createElement('style');
      style.dataset.aniMobileChat = '';
      style.textContent = '@media(max-width:767px){.main-element:not(.open):not(.iframe):not(.mounted){width:36px!important;height:36px!important;left:10px!important}.main-element:not(.open) .omni-button{width:36px!important;height:36px!important;min-width:36px!important;min-height:36px!important;box-shadow:0 2px 8px #2b334918!important}.main-element:not(.open) .omni-button svg{width:18px!important;height:18px!important}}';
      root.append(style);
    }
    return true;
  };
  if (!mount()) {
    const timer = setInterval(() => { if (mount() || ++attempts >= 120) clearInterval(timer); }, 500);
  }
  window.addEventListener('load', mount, {once:true});
  document.addEventListener('shopify:section:load', mount);
})();
